// Imports MUI
import { useMediaQuery, useTheme, Breakpoint } from '@mui/material'

/**
 *
 * @returns
 */
const useIsMobile = (breakPoint: Breakpoint) => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down(breakPoint))
}

export default useIsMobile
